import * as Yup from 'yup'

export const AuthFormSchema = Yup.object().shape({
  email: Yup.string()
    .email('Invalid email')
    .required('This field is required!'),
  password: Yup.string().min(3, 'Min. password 3').max(32, 'Max. password 32!'),
})

export const RegisterFormSchema = Yup.object().shape({
  password: Yup.string().min(3, 'Min.password 3!').max(32, 'Max. password 32!'),
  confirmPassword: Yup.string()
    .min(3, 'Min. confirm password 3!')
    .max(32, 'Max. confirm password 32!'),
  name: Yup.string().min(6, 'Minimal name 6!').max(1200, 'Max name 30!'),
  email: Yup.string().email('Invalid email').required('This field is required'),
  referralCode: Yup.string()
    .matches(/^[0-9]*$/, 'Only numbers.')
    .test('minLength', 'Min. referral code 12', (value) => {
      return value === undefined || value.length === 0 || value.length >= 12
    })
    .max(12, 'Max. referral code 12')
    .notRequired(),
})

export const ForgetPasswordEmailSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email').required('This field is required'),
})

export const NewPasswordSchema = Yup.object().shape({
  password: Yup.string().min(3, 'Min.password 3!').max(32, 'Max. password 32!'),
  passwordCopy: Yup.string()
    .min(3, 'Min.password 3!')
    .max(32, 'Max. password 32!'),
})

export const ReferralCodeSchema = Yup.object().shape({
  code: Yup.string()
    .matches(/^[0-9]*$/, 'Only numbers.')
    .min(12, 'Min. referral code 12')
    .max(12, 'Max. referral code 12'),
})

export const ProfileSchema = Yup.object().shape({
  userName: Yup.string()
    .matches(/^[a-zA-Z0-9._]+$/, 'Error validate.')
    .min(3, 'Min. username length 3')
    .max(50, 'Max. username length 50'),
})

export const ReferralIdForTransferSchema = Yup.object().shape({
  id: Yup.string(),
})
